module.exports = __webpack_public_path__ + "static/jci-india-0f9c62320fa5d2ed71855abc477cbfd2.png";